// === Quiz Data Object ===
const selectedData = {};
window.selectedQuizData = selectedData;

function logSelectedData() {
  console.log("Selected Data:", JSON.stringify(selectedData, null, 2));
}
window.getSelectedQuizData = () => selectedData;

// === Scroll to quiz-main on small screens ===
function scrollToQuizMainIfMobile() {
  const isSmallScreen = window.innerWidth <= 1080;
  console.log(isSmallScreen);
  if (isSmallScreen) {
    const quizMain = document.querySelector('#site-main');
    if (quizMain) {
      quizMain.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}

// === Utility: Sync radio inputs ===
function syncRadioInput(name, value) {
  document.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach(input => {
    input.checked = input.value === value;
  });
}

// === Utility: Sync UI with selectedData ===
function syncInputsWithData() {
  syncRadioInput("level", selectedData.level);
  syncRadioInput("player", selectedData.player);
  syncRadioInput("brand", selectedData.brand);
  syncRadioInput("style", selectedData.style);

  if (selectedData.budget) {
    minRange.value = selectedData.budget.min;
    maxRange.value = selectedData.budget.max;
    minVal.value = `$${selectedData.budget.min.toFixed(2)}`;
    maxVal.value = `$${selectedData.budget.max.toFixed(2)}`;
  }
}

// === Utility: Toggle animation class ===
function toggleAnimationClass(el, className) {
  if (!el) return;
  const alt = className === "right_animation" ? "left_animation" : "right_animation";
  el.classList.remove(alt);
  el.classList.add(className);
}

// === Landing Page ===
const landingButton = document.querySelector(".js-quiz-landing-btn");
const landingPage = document.querySelector(".quiz-landing");
const levelSection = document.querySelector(".js-level-section");

landingButton ? landingButton.addEventListener("click", function () {
  landingPage.classList.add("hidden");
  levelSection.classList.remove("hidden");
  toggleAnimationClass(levelSection, "right_animation");
  toggleAnimationClass(landingPage, "right_animation");
  syncInputsWithData();
  logSelectedData();
}) : "";

const backToLandingBtn = document.querySelector('.btn_previous_level');
backToLandingBtn ? backToLandingBtn.addEventListener('click', function () {
  landingPage.classList.remove('hidden');
  levelSection.classList.add('hidden');
  toggleAnimationClass(landingPage, "left_animation");
  syncInputsWithData();
  logSelectedData();
  scrollToQuizMainIfMobile();
}) : "";

// === Level Section ===
const quizSection = document.querySelector('.js-level-section');
const playerSection = document.querySelector('.js-player-section');
const levelInputs = quizSection.querySelectorAll('input[type="radio"][name="level"]');
const nextBtnLevel = quizSection.querySelector('.btn_next_level');
const skipBtnLevel = quizSection.querySelector('.btn_skip_level');
const collectionHandle = 'all';
const limit = 50;
let productsByLevelCache = {};
let latestRequestId = 0;

// fallback if not defined in your project
window.selectedData = window.selectedData || {};
window.logSelectedData = window.logSelectedData || function(){};

// ======================
// Progressive Fetch
// ======================
async function fetchProductsProgressive(level, onFirstMatches) {
  if (productsByLevelCache[level]) {
    return productsByLevelCache[level];
  }

  let requestId = ++latestRequestId;
  let page = 1;
  let hasMore = true;
  let matches = [];

  while (hasMore) {
    const res = await fetch(`/collections/${collectionHandle}/products.json?limit=${limit}&page=${page}`);
    const data = await res.json();

    const filtered = data.products.filter(product =>
      product.tags.some(tag => tag.toLowerCase() === level)
    );
    matches.push(...filtered);

    if (matches.length >= 2 && onFirstMatches && latestRequestId === requestId) {
      onFirstMatches(matches.slice(0, 2));
      onFirstMatches = null;
    }

    if (data.products.length < limit) {
      hasMore = false;
    } else {
      page++;
    }
  }
  productsByLevelCache[level] = matches;
  return matches;
}

// ======================
// Render Products
// ======================
function renderProductsInto(container, products) {
  if (!products.length) {
    container.innerHTML = `<div class="no-products">No products found for this step ❗</div>`;
    return;
  }

  container.innerHTML = `
    <div class="down-icon">
      <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle cx="25.5" cy="25.5" r="25" fill="white" stroke="black"/>
        <path d="M25.6338 18.1832L25.6338 33.0282" stroke="black"
          stroke-width="1.43662" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M31.3802 28.2874L25.6337 33.9859L19.8872 28.2874" stroke="black"
          stroke-width="1.43662" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <ul class="level-product-main"></ul>
  `;

  const ul = container.querySelector('.level-product-main');

  products.slice(0, 2).forEach(product => {
    const li = document.createElement('li');
    li.innerHTML = `
      <a href="${location.origin}/products/${product.handle}" 
         target="_blank" 
         rel="noopener noreferrer"  
         class="level-product-link"
         style="display:block; text-decoration:none; color:inherit;">
        <div class="level-product-image">
          <img src="${product.images?.[0]?.src || ''}" alt="${product.title}" />
        </div>
        <div class="level-product-title">${product.title}</div>
      </a>
    `;
    ul.appendChild(li);
  });

  ul.querySelectorAll("a.level-product-link").forEach(a => {
    a.addEventListener("click", (e) => {
      e.stopPropagation();
      window.open(a.href, "_blank", "noopener,noreferrer");
    });
  });
}

// ======================
// Clear Containers
// ======================
function clearAllProductContainers() {
  document.querySelectorAll('.js-level-up-product').forEach(container => {
    container.innerHTML = '';
  });
  document.querySelectorAll('.js-badminton-product').forEach(container => {
    container.innerHTML = '';
  });
   document.querySelectorAll('.js-style-product').forEach(container => {
    container.innerHTML = '';
  });
   
}

// ======================
// Level Selection Handler
// ======================
levelInputs.forEach(input => {
  input.addEventListener('change', async function () {
    if (this.checked) {
      const selectedLevel = this.value.trim().toLowerCase();
      selectedData['level'] = selectedLevel;
      logSelectedData();

      clearAllProductContainers();

      const quizCard = this.closest('.quiz_details');
      const productContainer = quizCard.querySelector('.js-level-up-product');

      // show loader
      productContainer.innerHTML = `<div class="loader"></div>`;

      fetchProductsProgressive(
        selectedLevel,
        firstMatches => renderProductsInto(productContainer, firstMatches)
      ).then(fullMatches => {
        renderProductsInto(productContainer, fullMatches);
      });
    }
  });
});




nextBtnLevel.addEventListener('click', function () {
  if (selectedData['level']) {
    syncInputsWithData();
    quizSection.classList.add('hidden');
    playerSection.classList.remove('hidden');
    toggleAnimationClass(playerSection, "right_animation");
    logSelectedData();
  } else {
    alert("Please select a level before continuing.");
  }
});

skipBtnLevel.addEventListener('click', function () {
  delete selectedData['level'];
  syncInputsWithData();
  quizSection.classList.add('hidden');
  playerSection.classList.remove('hidden');
  toggleAnimationClass(playerSection, "right_animation");
  logSelectedData();
});
function enableSubmitOnRadio(sectionSelector, radioName, submitBtnSelector) {
  const section = document.querySelector(sectionSelector);
  if (!section) return;

  const radios = section.querySelectorAll(`input[type="radio"][name="${radioName}"]`);
  const submitBtn = section.querySelector(submitBtnSelector);

  if (!submitBtn || radios.length === 0) return;

  // Initially disabled
  submitBtn.disabled = true;

  radios.forEach(radio => {
    radio.addEventListener("change", () => {
      if (section.querySelector(`input[name="${radioName}"]:checked`)) {
        submitBtn.disabled = false;
      }
    });
  });
}

// ✅ Apply to each quiz step
enableSubmitOnRadio(".js-level-section", "level", ".btn_submit_level");
enableSubmitOnRadio(".js-player-section", "player", ".btn_submit_player");
enableSubmitOnRadio(".js-control-section", "style", ".btn_submit_style");
enableSubmitOnRadio(".js-brand-prefrence", "brand", ".btn_submit_brand");

// === Player Section ===
const controlSection = document.querySelector('.js-control-section');
const playerRadios = playerSection.querySelectorAll('input[type="radio"][name="player"]');
const nextBtnPlayer = playerSection.querySelector('.btn_next_player');
const skipBtnPlayer = playerSection.querySelector('.btn_skip_player');
const prevBtnPlayer = playerSection.querySelector('.btn_previous_player');
const badmintonContainer = document.querySelector(".js-badminton-product");


playerRadios.forEach(input => {
  input.addEventListener('change', function () {
    if (this.checked) {
      let selectedPlayer = this.value.trim().toLowerCase();
      selectedData['player'] = selectedPlayer;
      logSelectedData();
      clearAllProductContainers();

      const quizCard = this.closest('.quiz_details');
      const productContainer = quizCard.querySelector('.js-badminton-product');

      // show loader
      productContainer.innerHTML = `<div class="loader"></div>`;

      fetchProductsProgressive(
        selectedPlayer,
        firstMatches => renderProductsInto(productContainer, firstMatches)
      ).then(fullMatches => {
        renderProductsInto(productContainer, fullMatches);
      });
    }
  });
});
nextBtnPlayer.addEventListener('click', function () {
  if (selectedData['player']) {
    syncInputsWithData();
    playerSection.classList.add('hidden');
    controlSection.classList.remove('hidden');
    toggleAnimationClass(controlSection, "right_animation");
    scrollToQuizMainIfMobile();
    logSelectedData();
  } else {
    alert('Please select a player level before proceeding.');
  }
});

skipBtnPlayer.addEventListener('click', function () {
  delete selectedData['player'];
  syncInputsWithData();
  playerSection.classList.add('hidden');
  controlSection.classList.remove('hidden');
  toggleAnimationClass(controlSection, "right_animation");
  logSelectedData();
});

prevBtnPlayer.addEventListener('click', function () {
  playerSection.classList.add('hidden');
  quizSection.classList.remove('hidden');
  toggleAnimationClass(quizSection, "left_animation");
  syncInputsWithData();
  logSelectedData();
  scrollToQuizMainIfMobile();
});

// === Control Section ===
const budgetSection = document.querySelector('.js-budget-section');
const controlRadios = controlSection.querySelectorAll('input[type="radio"][name="style"]');
const nextBtnControl = controlSection.querySelector('.btn_next_control');
const skipBtnControl = controlSection.querySelector('.btn_skip_control');
const prevBtnControl = controlSection.querySelector('.btn_previous_control');
const styleContainer = document.querySelector(".js-style-product");
controlRadios.forEach(radio => {
  radio.addEventListener('change', function () {
    if (this.checked) {
      const selectedControl = this.value.trim().toLowerCase();
      selectedData['style'] = selectedControl;
      logSelectedData();
      clearAllProductContainers();

      const quizCard = this.closest('.quiz_details');
      const productContainer = quizCard.querySelector('.js-style-product');

      // show loader
      productContainer.innerHTML = `<div class="loader"></div>`;

      fetchProductsProgressive(
        selectedControl,
        firstMatches => renderProductsInto(productContainer, firstMatches)
      ).then(fullMatches => {
        renderProductsInto(productContainer, fullMatches);
      });
    }
  });
});

nextBtnControl.addEventListener('click', function () {
  const selectedRadio = document.querySelector('input[type="radio"][name="style"]:checked');
  if (!selectedRadio) {
    alert("Please select a style preference.");
    return;
  }

  selectedData['style'] = selectedRadio.value;
  syncInputsWithData();
  controlSection.classList.add('hidden');
  budgetSection.classList.remove('hidden');
  toggleAnimationClass(budgetSection, "right_animation");
  logSelectedData();
});

skipBtnControl.addEventListener('click', function () {
  delete selectedData['style'];
  syncInputsWithData();
  controlSection.classList.add('hidden');
  budgetSection.classList.remove('hidden');
  toggleAnimationClass(budgetSection, "right_animation");
  logSelectedData();
});

prevBtnControl.addEventListener('click', function () {
  controlSection.classList.add('hidden');
  playerSection.classList.remove('hidden');
  toggleAnimationClass(playerSection, "left_animation");
  syncInputsWithData();
  logSelectedData();
  scrollToQuizMainIfMobile();
});

// === Budget Section ===
const brandSection = document.querySelector('.js-brand-prefrence');
const nextBtnBudget = document.querySelector('.btn_next_budget');
const skipBtnBudget = document.querySelector('.btn_skip_budget');
const prevBtnBudget = document.querySelector('.btn_previous_budget');

const minRange = document.getElementById("minRange");
const maxRange = document.getElementById("maxRange");
const minVal = document.getElementById("min-val");
const maxVal = document.getElementById("max-val");

// ✅ bubble references
const bubbleMin = document.getElementById("bubble-min");
const bubbleMax = document.getElementById("bubble-max");

const bubbleMinSp = document.getElementById("bubble-min-sp");
const bubbleMaxSp = document.getElementById("bubble-max-sp");

const progress = document.querySelector(".progress");

// ✅ bubble update function
function updateBubbles() {
  const min = parseFloat(minRange.value);
  const max = parseFloat(maxRange.value);

  const percent1 = (min / parseFloat(minRange.max)) * 100;
  const percent2 = (max / parseFloat(maxRange.max)) * 100;

  bubbleMinSp.textContent = `$${min}`;
  bubbleMaxSp.textContent = `$${max}`;

  bubbleMin.style.left = percent1 + "%";
  bubbleMax.style.left = percent2 + "%";
}

// ✅ progress bar update
function updateProgress() {
  const min = parseFloat(minRange.value);
  const max = parseFloat(maxRange.value);

  const percent1 = (min / parseFloat(minRange.max)) * 100;
  const percent2 = (max / parseFloat(maxRange.max)) * 100;

  progress.style.left = percent1 + "%";
  progress.style.width = (percent2 - percent1) + "%";
}

minRange.addEventListener("input", () => {
  const min = parseFloat(minRange.value);
  const max = parseFloat(maxRange.value);
  if (min > max) minRange.value = max;
  minVal.value = `$${parseFloat(minRange.value)}`;
  updateBubbles();
  updateProgress(); // ✅ fill between
  updateBudget();
});

maxRange.addEventListener("input", () => {
  const min = parseFloat(minRange.value);
  const max = parseFloat(maxRange.value);
  if (max < min) maxRange.value = min;
  maxVal.value = `$${parseFloat(maxRange.value)}`;
  updateBubbles();
  updateProgress(); // ✅ fill between
  updateBudget();
});

minVal.addEventListener("change", () => {
  const val = parseFloat(minVal.value.replace(/[^0-9.]/g, ''));
  const max = parseFloat(maxRange.value);
  if (!isNaN(val)) {
    minRange.value = Math.min(val, max);
    minVal.value = `$${parseFloat(minRange.value)}`;
    updateBubbles();
    updateProgress(); // ✅
    updateBudget();
  }
});

maxVal.addEventListener("change", () => {
  const val = parseFloat(maxVal.value.replace(/[^0-9.]/g, ''));
  const min = parseFloat(minRange.value);
  if (!isNaN(val)) {
    maxRange.value = Math.max(val, min);
    maxVal.value = `$${parseFloat(maxRange.value)}`;
    updateBubbles();
    updateProgress(); // ✅
    updateBudget();
  }
});

function updateBudget() {
  selectedData['budget'] = {
    min: parseFloat(minRange.value),
    max: parseFloat(maxRange.value)
  };
  logSelectedData();
}

const sliderBar = document.querySelector('.slider-bar');
sliderBar.addEventListener('click', (e) => {
  const rect = sliderBar.getBoundingClientRect();
  const clickX = e.clientX - rect.left;
  const percent = clickX / rect.width;

  const min = parseFloat(minRange.min);
  const max = parseFloat(maxRange.max);
  const value = min + percent * (max - min);
  const rounded = parseFloat(value);

  const minDiff = Math.abs(rounded - parseFloat(minRange.value));
  const maxDiff = Math.abs(rounded - parseFloat(maxRange.value));

  if (minDiff < maxDiff) {
    minRange.value = Math.min(rounded, parseFloat(maxRange.value));
    minVal.value = `$${parseFloat(minRange.value)}`;
  } else {
    maxRange.value = Math.max(rounded, parseFloat(minRange.value));
    maxVal.value = `$${parseFloat(maxRange.value)}`;
  }

  updateBubbles();
  updateProgress(); // ✅ keep synced
  updateBudget();
});

// ✅ initialize bubbles & progress on load
updateBubbles();
updateProgress();



nextBtnBudget.addEventListener('click', function () {
  if (selectedData['budget']) {
    syncInputsWithData();
    budgetSection.classList.add('hidden');
    brandSection.classList.remove('hidden');
    toggleAnimationClass(brandSection, "right_animation");
    logSelectedData();
  } else {
    alert("Please adjust your budget range.");
  }
});

skipBtnBudget.addEventListener('click', function () {
  delete selectedData['budget'];
  syncInputsWithData();
  budgetSection.classList.add('hidden');
  brandSection.classList.remove('hidden');
  toggleAnimationClass(brandSection, "right_animation");
  logSelectedData();
});

prevBtnBudget.addEventListener('click', function () {
  budgetSection.classList.add('hidden');
  controlSection.classList.remove('hidden');
  toggleAnimationClass(controlSection, "left_animation");
  syncInputsWithData();
  logSelectedData();
  scrollToQuizMainIfMobile();
});

// === Brand Section ===
const productSection = document.querySelector('.js-product-section');
const brandRadios = brandSection.querySelectorAll('input[type="radio"]');
const nextBtnBrand = brandSection.querySelector('.btn_next_brand');
const skipBtnBrand = brandSection.querySelector('.btn_skip_brand');
const prevBtnBrand = brandSection.querySelector('.btn_previous_brand');

brandRadios.forEach(radio => {
  radio.addEventListener('change', () => {
    if (radio.checked) {
      selectedData['brand'] = radio.value;
      logSelectedData();
    }
  });
});

skipBtnBrand.addEventListener('click', () => {
  delete selectedData['brand'];
  syncInputsWithData();
  brandSection.classList.add('hidden');
  productSection.classList.remove('hidden');
  toggleAnimationClass(productSection, "right_animation");
  logSelectedData();
  filterProductsBasedOnQuiz();
});

prevBtnBrand.addEventListener('click', () => {
  brandSection.classList.add('hidden');
  budgetSection.classList.remove('hidden');
  toggleAnimationClass(budgetSection, "left_animation");
  syncInputsWithData();
  logSelectedData();
  scrollToQuizMainIfMobile();
});
function formatPrice(value) {
  const num = parseFloat(value);
  if (isNaN(num)) return "";
  return num % 1 === 0 ? num.toString() : num.toFixed(2); // removes .00 if whole number
}
// === Product Filter ===
async function fetchAllProducts(initialContainerId = "quiz_cate_row") {
  const parser = new DOMParser();
  let allProducts = [];

  const processPage = (doc) => {
    const cards = doc.querySelectorAll(`#${initialContainerId} .quiz_cate_card`);
    cards.forEach(card => {
      const anchor = card.querySelector("a.js-product-select");
      if (!anchor) return;

      allProducts.push({
        html: card.outerHTML, // store string, not live DOM
        level: new Set((anchor.getAttribute("data-level") || "").split(",").map(v => v.trim().toLowerCase())),
        player: new Set((anchor.getAttribute("data-player") || "").split(",").map(v => v.trim().toLowerCase())),
        style: new Set((anchor.getAttribute("data-control") || "").split(",").map(v => v.trim().toLowerCase())),
        price: parseFloat(anchor.getAttribute("data-price") || "0"),
        brand: (anchor.getAttribute("data-brand") || "").trim().toLowerCase()
      });
    });
  };

  // process first page
  processPage(document);

  // process pagination
  let nextUrl = document.querySelector("#loadMoreBtn")?.getAttribute("data-next-url");
  while (nextUrl) {
    const response = await fetch(nextUrl);
    const text = await response.text();
    const doc = parser.parseFromString(text, "text/html");

    processPage(doc);

    const newNextBtn = doc.querySelector("#loadMoreBtn");
    nextUrl = newNextBtn ? newNextBtn.getAttribute("data-next-url") : null;
  }

  return allProducts;
}


// Global cache so we fetch once only
let productCache = null;

// Create and insert loader inside container
function showLoader(container, text = "Loading products...") {
  // clear container while loading
  container.innerHTML = "";

  const loader = document.createElement("div");
  loader.id = "quiz-loader";
  loader.style.cssText = `
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    flex-direction: column;
  `;
  loader.innerHTML = `
    <div class="spinner" style="
      width: 40px;
      height: 40px;
      border: 4px solid #ccc;
      border-top: 4px solid #333;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    "></div>
    <span class="loader-text">${text}</span>
  `;

  // Spin animation (only inject once)
  if (!document.querySelector("#quiz-loader-style")) {
    const style = document.createElement("style");
    style.id = "quiz-loader-style";
    style.textContent = `
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  container.appendChild(loader);
}

// Remove loader from container
function hideLoader(container) {
  const loader = container.querySelector("#quiz-loader");
  if (loader) loader.remove();
}


async function filterProductsBasedOnQuiz() {
  const productContainer = document.getElementById("quiz_cate_row");
  const messageEl = document.querySelector(".no-product-message");
  const loadMoreBtn = document.getElementById("loadMoreBtn");
  if (!productContainer) return;

  // Hide load more button during loading
  if (loadMoreBtn) loadMoreBtn.style.display = "none";

  // Show loader inside container
  showLoader(productContainer, "Fetching products...");

  // Fetch once only
  if (!productCache) {
    productCache = await fetchAllProducts("quiz_cate_row");
  }

  // Remove loader after fetching
  hideLoader(productContainer);

  const { level, player, style, budget, brand } = selectedData;
  const lvl = level?.toLowerCase();
  const ply = player?.toLowerCase();
  const sty = style?.toLowerCase();
  const brd = brand?.toLowerCase();

  // Filtering
  const filtered = productCache.filter(prod => {
    if (lvl && !prod.level.has(lvl)) return false;
    if (ply && !prod.player.has(ply)) return false;
    if (sty && !prod.style.has(sty)) return false;
    if (brd && prod.brand !== brd) return false;
    if (budget && (prod.price < budget.min || prod.price > budget.max)) return false;
    return true;
  });

  // Clear container before rendering
  productContainer.innerHTML = "";

  if (filtered.length === 0) {
    if (messageEl) messageEl.style.display = "flex";
    if (loadMoreBtn) loadMoreBtn.style.display = "none";
    return;
  }
  if (messageEl) messageEl.style.display = "none";

  const maxPerPage = 50;
  let currentIndex = 0;

  function renderBatch() {
    const fragment = document.createDocumentFragment();
    const nextBatch = filtered.slice(currentIndex, currentIndex + maxPerPage);

    nextBatch.forEach(prod => {
      const div = document.createElement("div");
      div.innerHTML = prod.html;
      fragment.appendChild(div.firstElementChild);
    });

    productContainer.appendChild(fragment);
    currentIndex += nextBatch.length;

    if (currentIndex >= filtered.length) {
      if (loadMoreBtn) loadMoreBtn.style.display = "none";
    } else {
      if (loadMoreBtn) loadMoreBtn.style.display = "flex";
    }
  }

  // Render first batch
  renderBatch();

  // Enable load more only after initial render
  if (loadMoreBtn) {
    loadMoreBtn.onclick = () => renderBatch();
  }
}


// === Product Back Button ===
const prevBtnProduct = document.querySelector('.btn_previous_product');
prevBtnProduct.addEventListener('click', () => {
  brandSection.classList.remove('hidden');
  productSection.classList.add('hidden');
  toggleAnimationClass(brandSection, "left_animation");
  syncInputsWithData();
  logSelectedData();
  scrollToQuizMainIfMobile();
});

// === Product Selection + Cart ===
const selectedVariants = new Set();

document.querySelectorAll('.js-product-select').forEach(checkbox => {
  checkbox.addEventListener('change', function () {
    const variantId = this.value;
    this.checked ? selectedVariants.add(variantId) : selectedVariants.delete(variantId);
    // console.log("Selected Variants:", [...selectedVariants]);
  });
});

const addToCartBtn = document.querySelector('.js-add-to-cart-btn');

addToCartBtn ? addToCartBtn.addEventListener('click', function () {
  addToCartBtn.classList.add("loadding");

  if (selectedVariants.size === 0) {
    alert("Please select at least one product.");
    return;
  }

  const items = [...selectedVariants].map(id => ({ id, quantity: 1 }));

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ items })
  })
    .then(response => {
      if (!response.ok) throw new Error('Add to cart failed.');
      return response.json();
    })
    .then(data => {
      // console.log('Cart updated:', data);
      addToCartBtn.classList.remove("loadding");
    })
    .catch(error => {
      console.error('Error:', error);
      alert('There was a problem adding products to the cart.');
    });
}) : '';

// === Global Submit Buttons ===
const submitButtons = document.querySelectorAll(`
  .btn_submit_level,
  .btn_submit_player,
  .btn_submit_style,
  .btn_submit_budget,
  .btn_submit_brand
`);

submitButtons.forEach(btn => {
  btn.addEventListener('click', () => {
    const selectedRadio = document.querySelector('input[type="radio"][name="style"]:checked');
    selectedData['style'] = selectedRadio ? selectedRadio.value : undefined;

    [
      // landingPage,
      levelSection,
      playerSection,
      controlSection,
      budgetSection,
      brandSection
    ].forEach(section => section.classList.add('hidden'));

    productSection.classList.remove('hidden');
    toggleAnimationClass(productSection, "right_animation");

    syncInputsWithData();
    logSelectedData();
    filterProductsBasedOnQuiz();
  });
});


// load more functionaity

const loadMoreBtn = document.getElementById("loadMoreBtn");
  const productContainer = document.getElementById("quiz_cate_row");

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener("click", function() {
      const nextUrl = loadMoreBtn.getAttribute("data-next-url");

      if (!nextUrl) return;

      loadMoreBtn.textContent = "Loading...";

      fetch(nextUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newProducts = doc.querySelectorAll(".quiz_cate_card");

          newProducts.forEach(product => {
            productContainer.appendChild(product);
          });

          const newNextBtn = doc.getElementById("loadMoreBtn");
          if (newNextBtn) {
            loadMoreBtn.setAttribute("data-next-url", newNextBtn.getAttribute("data-next-url"));
            loadMoreBtn.textContent = "Load More";
          } else {
            loadMoreBtn.textContent = "No More Products";
            loadMoreBtn.disabled = true;
          }
        })
        .catch(err => {
          console.error(err);
          loadMoreBtn.textContent = "Error Loading";
        });
    });
  }
// === Animation + radio_active highlight ===
function setupQuizAnimations(sectionSelector) {
  const section = document.querySelector(sectionSelector);
  if (!section) return;

  const quizDetails = section.querySelectorAll(".quiz_details");
  if (quizDetails.length === 0) return;

  const firstQuizBox = quizDetails[0];

  quizDetails.forEach(detail => {
    const radio = detail.querySelector("input[type='radio']");

    detail.addEventListener("click", () => {
      if (radio) {
        radio.checked = true;
        // 🔥 trigger change so existing listeners fire
        const event = new Event("change", { bubbles: true });
        radio.dispatchEvent(event);
      }

      // Highlight
      quizDetails.forEach(d => d.classList.remove("radio_active"));
      detail.classList.add("radio_active");

      if (detail === firstQuizBox) return; // no anim if first clicked

      // Animation swap
      const rect1 = firstQuizBox.getBoundingClientRect();
      const rect2 = detail.getBoundingClientRect();

      const dx = rect1.left - rect2.left;
      const dy = rect1.top - rect2.top;

      detail.classList.add("animate");
      firstQuizBox.classList.add("animate");

      detail.style.transform = `translate(${dx}px, ${dy}px)`;
      firstQuizBox.style.transform = `translate(${-dx}px, ${-dy}px)`;

      setTimeout(() => {
        detail.style.transform = "translate(0,0)";
        firstQuizBox.style.transform = "translate(0,0)";
        void detail.offsetWidth;
        void firstQuizBox.offsetWidth;
        detail.classList.remove("animate");
        firstQuizBox.classList.remove("animate");
      }, 600);
    });
  });
}

// ✅ Call for each quiz step
setupQuizAnimations(".js-level-section");
setupQuizAnimations(".js-player-section");
setupQuizAnimations(".js-control-section");
// add more if you have budget/brand sections
